import React, { useState, useEffect } from "react";
import PopupForm from "./PopupForm.js"; // Import the Popup Form
import "./BankDataSolution.css";

const services = [
  {
    title: "Bank Audit Revolution - Data Mining",
    description:
      "The banking sector generates an enormous volume of data, making audits complex and time-sensitive. Our advanced data solutions help banks analyze massive datasets efficiently, ensuring security, compliance, and fraud prevention. Take control of your financial data now!",
  },
  {
    title: "Challenges in Bank Audits",
    description:
      "The banking sector handles vast amounts of unstructured reports, making it difficult to verify transactions in time-sensitive assignments. For instance, balance reports often have 50K line items spanning over 700+ pages with files exceeding 5MB in size.",
  },
  {
    title: "Our Data-Driven Approach",
    description:
      "Our data mining process is based on mathematical algorithms, analytical skills, and IT tools. We provide structured analysis reports within 3 minutes, enabling faster verification and improved audit efficiency.",
  },
  {
    title: "Step-by-Step Audit Data Processing",
    description:
      "1️⃣ Collect Data from Core Banking System (CBS)\n2️⃣ Clean and Transform Data\n3️⃣ Analyze Data\n4️⃣ Generate Structured Reports\nThis process ensures accuracy and efficiency in bank audits.",
  },
  {
    title: "Input Requirements for Data Extraction",
    description:
      "We extract data directly from Core Banking Solutions (CBS) of respective branches. We also assist with formulas, processes, and code for efficient data extraction from CBS environments.",
  },
  {
    title: "Delivered Insights & Reports",
    description:
      "After data mining, we provide:\n✅ Structured reports for verification\n✅ Audit samples with questionnaires\n✅ Improved audit documentation\n✅ Reduced compliance risks and audit duration.",
  },
  {
    title: "Advantages of Our Banking Data Solution",
    description:
      "🔹 Process massive banking data within 3 minutes\n🔹 Provide formulas & codes for CBS data extraction\n🔹 Generate various structured output files\n🔹 Offer the best audit samples with checklists\n🔹 Enhance audit documentation for compliance.",
  },
  {
    title: "Who Can Benefit from Our Solutions?",
    description:
      "Our banking data solutions are effective for:\n- Branch Audit\n- Concurrent Audit\n- Statutory Bank Audit (SBA)\n- Revenue Audit\n- Investigation Agencies\n- Controlling Authorities, and more.",
  }
];

const BankDataSolution = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false); // Track hover state

  // Function to open the PDF in a new tab
  const openPDF = () => {
    window.open("./Data Bolta Hi_Bank.pdf");
  };

  // // Function to navigate to the project page
  // const goToProject = () => {
  //   window.location.href = "/vendor-form"; // Change this to your actual project route
  // };

  // Function to go to the next service
  const nextService = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
  };

  // Function to go to the previous service
  const prevService = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? services.length - 1 : prevIndex - 1
    );
  };

  // Auto-change services every 10 seconds, but stop when hovered
  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        nextService();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isHovered]); // Re-run when hover state changes

  return (
    <div className="bank-data-container">
      {/* Hero Section */}
      <section className="hero-bank-section">
        <div className="hero-content">
          <h1>Bank Data Solution</h1>
          <p>
            Optimize financial data management with secure and scalable banking solutions.
          </p>
          <div className="hero-buttons-wrapper">
            <button className="connect-now-btn" onClick={() => setIsPopupOpen(true)}>
              Connect Now!
            </button>
            <button className="open-pdf-btn" onClick={openPDF}>
              View PDF
            </button>
            {/* <button className="connect-now-btn" onClick={goToProject}>
              Go to Project
            </button> */}
          </div>
        </div>
      </section>

      {/* About Bank Data Solution */}
      <section className="about-bd-section">
        <div className="about-content">
          <div className="vector-image">
            <img src="./bd-img.png" alt="Big Data Vector" />
          </div>

          <div className="about-text">
            <h2>What is Bank Data Solution?</h2>
            <p>
              Our system helps banks and financial institutions analyze large amounts of transactional data to detect fraud, manage risk, and improve financial decision-making.
            </p>
            <ul>
              <li>🔹 AI-Powered Fraud Detection</li>
              <li>🔹 Real-time Transaction Monitoring</li>
              <li>🔹 Secure Data Processing & Compliance</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our Bank Data Solution?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🔒</span>
            <h3>Secure Transactions</h3>
            <p>End-to-end encryption for banking data security.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📊</span>
            <h3>Data Insights</h3>
            <p>AI-powered analysis for financial decision-making.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⚡</span>
            <h3>Real-Time Processing</h3>
            <p>Fast and reliable financial data handling.</p>
          </div>
        </div>
      </section>

      {/* Carousel Section */}
      <section className="bd-bottom-section">
        <h2>Transform Your Banking Data Today</h2>
        <div
          className="service-carousel"
          onMouseEnter={() => setIsHovered(true)}  // Stop auto-scroll when hovered
          onMouseLeave={() => setIsHovered(false)} // Resume auto-scroll when unhovered
        >
          <div className="service-card">
            <h3>{services[currentIndex].title}</h3>
            <p>{services[currentIndex].description}</p>
            <div className="carousel-controls">
              <button onClick={prevService}>&#9665;</button> {/* Left arrow */}
              <button onClick={nextService}>&#9655;</button> {/* Right arrow */}
            </div>
          </div>
        </div>
      </section>

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default BankDataSolution;
